module.exports = __webpack_public_path__ + "static/media/resources-icon-active.7bb08557.svg";